
     
  document.addEventListener("DOMContentLoaded", function () {
    const btn = document.getElementById("scrollBtn");

    window.addEventListener("scroll", function () {
      if (window.scrollY > 350) {
        btn.classList.add("show");
      } else {
        btn.classList.remove("show");
      }
    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const scrollBtn = document.getElementById("scrollBtn");

  scrollBtn.addEventListener("click", function () {

    const form = document.querySelector('[data-product-form]');
    const realBtn = form ? form.querySelector('.add_to_cart') : null;

    if (!form || !realBtn) return;

    form.scrollIntoView({ behavior: "smooth", block: "center" });

    setTimeout(() => {
      realBtn.click();
    }, 300);
  });
});
